import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/disputes/layouts/default.vue").then(m => m.default || m)),
  "claim-lab": defineAsyncComponent(() => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/claim-lab/layouts/claim-lab.vue").then(m => m.default || m)),
  "auth-public": defineAsyncComponent(() => import("#build/layouts.public.AtBZXxiGBRDIphkHQJsAblLwjMLOCdayZyJQYbQHunQ.vue").then(m => m.default || m))
}